export default "__VITE_ASSET__b6355797__"